import { render, staticRenderFns } from "./UpdateUserDataForm.vue?vue&type=template&id=1760faf8&"
import script from "./UpdateUserDataForm.vue?vue&type=script&lang=js&"
export * from "./UpdateUserDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports